/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { Footer } from '@components/systems'
import Markdown from 'markdown-to-jsx'

import { policyDocStyle } from './policyDoc.style'

/**
 * Store Policy — Monolith(2안). 구 페이지는 `pages/home/StorePolicy.page.tsx` 에 보관.
 *
 * 문서(`policies/storePolicy_en.md`)는 그대로다. Privacy Policy 와 같은 규격을 공유한다
 * (`policyDoc.style.ts`) — 두 장이 같은 문서 페이지라 따로 놀 이유가 없다.
 */
const MonolithStorePolicyPage = () => {
	// state
	const [markdown, setMarkdown] = React.useState<string>('')

	React.useEffect(() => {
		let isAlive = true

		import('../policies/storePolicy_en.md')
			.then(res => fetch(res.default))
			.then(res => res.text())
			.then(text => {
				if (isAlive) setMarkdown(text)
			})
			.catch(() => {
				if (isAlive) setMarkdown('')
			})

		return () => {
			isAlive = false
		}
	}, [])

	return (
		<View css={style}>
			<View className="mnWrap">
				<View className="mnDoc">
					{markdown === '' ? (
						<span className="mnDocQuiet">Loading</span>
					) : (
						<Markdown>{markdown}</Markdown>
					)}
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default MonolithStorePolicyPage

const style = css({
	...policyDocStyle,
})
